<template>
  <BaseInputText v-bind="$attrs"
                 v-on="$listeners"
                 v-model="input"
                 :inputContainerStyle="inputContainerStyle"
                 :inputStyle="inputStyle">
    <template v-slot:fixed-plugin-left>
      <slot name="fixed-plugin-left" />
    </template>
    <template v-slot:plugin-left>
      <slot name="plugin-left" />
    </template>
    <template v-slot:plugin-right>
      <slot name="plugin-right" />
    </template>
    <template v-slot:clear-button>
      <slot name="clear-button" />
    </template>
    <template v-slot:error-symbol>
      <slot name="error-symbol" />
    </template>
    <template v-slot:lock-symbol>
      <slot name="lock-symbol" />
    </template>
    <template v-slot:fixed-plugin-right>
      <slot name="fixed-plugin-right">
        <div :style="{ display: 'flex', alignItems: 'center', height: '100%' }">
          <BaseGoogleIcon v-bind="iconContainerStyle"
                          :content="iconContent"
                          :disabled="disabled"
                          :iconStyle="iconStyle"
                          @click.prevent="onClick"/>
        </div>
      </slot>
    </template>
    <template v-slot:popover>
      <slot name="popover" />
    </template>
  </BaseInputText>
</template>

<script>
  import BaseGoogleIcon from '@base/base-google-icon'
  import BaseInputText from '@base/base-input-text'

  export default {
    name: 'BaseSearchBox',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'input',
    },
    components: {
      BaseGoogleIcon,
      BaseInputText,
    },
    props: {
      vmodelValue: { type: String },
      disabled: { type: Boolean, required: false, default: false },
      iconContent: { type: String, required: false, default: 'search' },
      iconContainerStyle: { type: Object, required: false, default: () => {}},
      iconStyle: { type: Object, required: false, default: () => {}},
      inputContainerStyle: { type: Object, required: false, default: () => {}},
      inputStyle: { type: Object, required: false, default: () => {}},
    },
    data: function () {
      return {
        input: '',
      };
    },
    created: function () {
      this.input = this.vmodelValue;
    },
    methods: {
      onClick: function () {
        if (!this.disabled) {
          this.$emit('search', this.input);
        }
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.input = newVal;
      },
    },
  };
</script>
